var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33331C10.8 3.33331 3.33331 10.8 3.33331 20C3.33331 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6666 29.2 36.6666 20C36.6666 10.8 29.2 3.33331 20 3.33331ZM20 8.33331C22.7666 8.33331 25 10.5666 25 13.3333C25 16.1 22.7666 18.3333 20 18.3333C17.2333 18.3333 15 16.1 15 13.3333C15 10.5666 17.2333 8.33331 20 8.33331ZM20 32C15.8333 32 12.15 29.8666 9.99998 26.6333C10.05 23.3166 16.6666 21.5 20 21.5C23.3166 21.5 29.95 23.3166 30 26.6333C27.85 29.8666 24.1666 32 20 32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.65a055f0baf8d398c294ef245a231304.svg";
export { ForwardRef as ReactComponent };